module.exports = __webpack_public_path__ + "static/img/PID-Selected.0f0efaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fileTypes/PID-Selected.png
// module id = 612
// module chunks = 0